// @ts-ignore
/* eslint-disable */
import { request } from "@umijs/max";

/** 5401-根据用户id获取用户的钱包信息 POST /v1/app/payUserWallets/getUserPayUserWalletsByUserId/${param0} */
export async function getUserPayUserWalletsByUserId(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.getUserPayUserWalletsByUserIdParams,
  options?: { [key: string]: any }
) {
  const { userId: param0, ...queryParams } = params;
  return request<API.YmResultVOListTPayUserWalletsVO>(
    `/v1/app/payUserWallets/getUserPayUserWalletsByUserId/${param0}`,
    {
      method: "POST",
      params: { ...queryParams },
      ...(options || {}),
    }
  );
}

/** 5402-获取钱包明细分页列表 POST /v1/app/payUserWallets/getWalletsAccountPageList */
export async function getWalletsAccountPageList(
  body: API.SwimWalletsAccountPageQueryVo,
  options?: { [key: string]: any }
) {
  return request<API.YmResultVOYmPageResVOSwimWalletsAccountBasicVo>(
    "/v1/app/payUserWallets/getWalletsAccountPageList",
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      data: body,
      ...(options || {}),
    }
  );
}
